import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MapUtils } from 'src/app/shared/utils/map-utils';
import { Coordenada } from 'src/app/models/entities/coordenada';
import { CapaSegmentosDTO } from 'src/app/models/dtos/capa-segmentos-dto';
import { Segmento } from 'src/app/models/entities/segmento';
import { LevantamientoSeleccionadoDTO } from 'src/app/models/dtos/levantamiento-seleccionado-dto';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ArchivoCoordenada } from 'src/app/models/entities/archivo-coordenada';
import { MapsAPILoader, AgmMarker } from '@agm/core';
import { } from 'googlemaps';
import { InfoWindow } from '@agm/core/services/google-maps-types';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take, concatMap, map, toArray, filter, tap, pairwise } from 'rxjs/operators';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { AvanceDTO } from 'src/app/models/dtos/avance-dto';
import { SegmentoService } from 'src/app/services/segmento.service';
import { CapaService } from 'src/app/services/capa.service';
import { ArchivoCoordenadaService } from 'src/app/services/archivo-coordenada.service';
import { Capa } from 'src/app/models/entities/capa';
import { from } from 'rxjs';
import { LevantamientoObra } from 'src/app/models/entities/levantamiento-obra';
import { Usuario } from 'src/app/models/entities/usuario';
import { LevantamientoObraService } from 'src/app/services/levantamiento-obra.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Estado } from 'src/app/models/entities/estado';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ObraService } from 'src/app/services/obra.service';
import { Obra } from 'src/app/models/entities/obra';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { LoaderService } from 'src/app/services/loader.service';
import { EstadoRouteService } from 'src/app/services/estado-route.service';
import { EjercicioFiscal } from 'src/app/models/ejercicio-fiscal';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
declare const google: any;
@Component({
  selector: 'larguillo',
  templateUrl: './larguillo.component.html',
  styleUrls: ['./larguillo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LarguilloComponent implements OnInit {

  public ocultarElementos: boolean = false;


  public readonly CAPA_PROYECTO_PROCESO: string = '0';
  public readonly CAPA_PROYECTO_PLANEACION: string = '4';
  public readonly CAPA_META_ACTUAL: string = '1';
  public readonly CAPA_COMPLETADO: string = '2';
  public readonly CAPA_ESTRUCTURA: string = '5';
  public catColores: ElementoCatalogo[] = [];
  public catCapas: ElementoCatalogo[] = [];
  public catEstados: Estado[];
  public catDireccionesAdjuntas: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catSecciones: ElementoCatalogo[];
  public catCarpetas: ElementoCatalogo[];

  @Input('mostrarBtnRegresar')
  public mostrarBtnRegresar: boolean = true;

  @ViewChild('modalGaleria')
  public modalGaleria: NgbModalRef;
  public refModalGaleria: NgbModalRef;
  public avanceSeleccionado: AvanceDTO;
  public datosObra: LevantamientoSeleccionadoDTO;
  public map: any;
  public iconoMultimedia: any = {
    url: '../../../../../assets/img/iconos/icono-multimedia.png',
    scaledSize: {
      width: 20,
      height: 20
    }
  };
  public iconoPuente: any = {
    url: '../../../../../assets/img/iconos/icono-puente.png',
    scaledSize: {
      width: 20,
      height: 20
    }
  };
  public iconoCoordenada: any = {
    url: '../../../../../assets/img/iconos/coordenada-disponible.png',
    scaledSize: {
      width: 5,
      height: 5
    }
  };
  public iconoInicioFin: any;
  public readonly KEY_COLOR_CAPA_COMPLETADO: string = '2';
  public hexColorCapaCompletado: string = '';
  public archivosSeleccionados: ArchivoCoordenada[];
  public coordenadaInicial: Coordenada;
  public coordenadaFinal: Coordenada;
  public coordenadaInfoWindow: Coordenada;
  public coordenadaImagenInfoWindow: Coordenada;
  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto = false;
  public COLOR_PARA_RESALTAR: string = '#e80000';
  public valorCheckbox: boolean = true;
  public colorSegmentosSeleccionados: string = '';
  public fechaActual: Date = new Date();
  public nombreMesEspanol: string = '';

  public enlaces: Array<Coordenada[]> = [];
  public inicioEnlace: Coordenada = null;
  public finEnlace: Coordenada = null;

  public avanceKmConcluido: number = 0;
  public avanceMdpConcluido: number = 0;
  public avanceKmActual: number = 0;
  public avanceMdpActual: number = 0;
  public avanceKmFaltante: number = 0;
  public avanceMdpFaltante: number = 0;

  public mostrarConcluido: boolean = false;
  public mostrarActual: boolean = false;
  public mostrarFaltante: boolean = false;

  public rutaAnterior: string = '';
  public anioActual = new Date().getFullYear();
  public readonly CARRETERAS_FEDERALES: string = '1';

  constructor(
    private mapUtils: MapUtils,
    private ngbModalService: NgbModal,
    private cd: ChangeDetectorRef,
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private archivoCoordenadaService: ArchivoCoordenadaService,
    private catalogoService: CatalogoService,
    private mapsAPILoader: MapsAPILoader,
    private levantamientoObraService: LevantamientoObraService,
    private usuarioService: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private obraServuce: ObraService,
    private dateUtils: DateUtils,
    private loaderService: LoaderService,
    private estadoRouteService: EstadoRouteService,
    public facadeSesionService: FacadeSesionService,
    private pdfUtils: PdfUtils
  ) {


  }

  public async ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Larguillo de la obra');
    this.loaderService.activarLoaderScreen('Cargando datos del larguillo');
    this.rutaAnterior = this.estadoRouteService.rutaAnterior;
    await this.mapsAPILoader.load();
    await this.obtenerCatalogos();
    await this.obtenerDatosLevantamiento(this.activatedRoute.snapshot.params.keyLevantamientoObra);
    this.iconoInicioFin = {
      url: '../../../../../assets/img/iconos/marker-red.png',
      scaledSize: {
        width: 25,
        height: 25
      },
      labelOrigin: new google.maps.Point(0, 0)
    };
    this.coordenadaInicial = this.mapUtils.obtenerCoordenadaInicialArregloPolylines(this.crearArregloPolylineProyecto());
    this.coordenadaFinal = this.mapUtils.obtenerCoordenadaFinalArregloPolylines(this.crearArregloPolylineProyecto());
    this.nombreMesEspanol = this.dateUtils.idiomaEspanol.monthNames[this.fechaActual.getMonth() - 1];
    this.cd.detectChanges();
  }

  public inicioDrag(event: any, coordenadaRecibida: Coordenada) {
    this.inicioEnlace = coordenadaRecibida;
  }

  public finDrag(event: any) {
    this.finEnlace = {
      latitud: event.coords.lat,
      longitud: event.coords.lng
    };

    let indiceEncontrado: number = -1;
    this.enlaces.forEach((enlace: Coordenada[], indiceEnlace: number) => {
      let indiceCoordenadaEncontrada: number = enlace.findIndex((c: Coordenada) => c.latitud === this.inicioEnlace.latitud && c.longitud === this.inicioEnlace.longitud);
      if (indiceCoordenadaEncontrada !== -1) {
        this.inicioEnlace === enlace[indiceCoordenadaEncontrada];
        indiceEncontrado = indiceEnlace;
      }
    });
    if (indiceEncontrado !== -1) {
      this.enlaces.splice(indiceEncontrado, 1);
    }
    let nuevoEnlace = [];
    nuevoEnlace.push(this.inicioEnlace, this.finEnlace);
    this.enlaces.push(nuevoEnlace);

  }


  public markerImagenAbierta(event: any, coordenada: Coordenada) {

  }

  public cerrarInfoWindowImagen(coordenada: Coordenada) {

  }



  public async obtenerCatalogos(): Promise<any> {
    let colorCompletado: ElementoCatalogo = await this.catalogoService.obtenerElementoDeCatalogoPorKey<ElementoCatalogo>(RutaCatalogoEnum.COLORES, this.KEY_COLOR_CAPA_COMPLETADO).pipe(take(1)).toPromise();
    this.hexColorCapaCompletado = colorCompletado.nombre;
    this.catColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCapas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS).pipe(take(1)).toPromise();
    this.catEstados = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS).pipe(take(1)).toPromise();
    this.catTipoObra = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    this.catTipoLevantamiento = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS).pipe(take(1)).toPromise();
    this.catSubElementos = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS).pipe(take(1)).toPromise();
    this.catColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCapas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS).pipe(take(1)).toPromise();
    this.catCarpetas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CARPETAS).pipe(take(1)).toPromise();
    this.catSecciones = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SECCIONES).pipe(take(1)).toPromise();
  }

  public obtenerNombreCarpeta(keyCatCarpeta: string) {
    return this.catCarpetas.find((carpeta: ElementoCatalogo) => carpeta.key === keyCatCarpeta).nombre
  }

  public obtenerNombreSeccion(keyCatSeccion: string) {
    return this.catSecciones.find((seccion: ElementoCatalogo) => seccion.key === keyCatSeccion).nombre
  }

  public seleccionarCoordenada(event: any) {
    this.coordenadaImagenInfoWindow = {
      latitud: event.coords.lat,
      longitud: event.coords.lng
    };
  }


  public abrirModalGaleria(archivosSeleccionados: ArchivoCoordenada[]) {
    this.archivosSeleccionados = archivosSeleccionados;
    this.refModalGaleria = this.ngbModalService.open(this.modalGaleria, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-lev-web',
      backdrop: 'static',
      keyboard: false
    });
  }

  public centrarMapa() {
    this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.datosObra.capasSegmentos));
  }

  public mouseOver(event: any, infoWindow: InfoWindow, avance: AvanceDTO): any {
    this.coordenadaInfoWindow = {
      latitud: event.latLng.lat(),
      longitud: event.latLng.lng()
    };
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    this.infoWindowAbierto = true;
    this.colorSegmentosSeleccionados = this.COLOR_PARA_RESALTAR;
    setTimeout(() => {
      this.avanceSeleccionado = avance;
      this.cd.detectChanges();
    }, 10);
  }


  public infoWindowClose(): void {
    if (this.avanceSeleccionado && this.infoWindowAbierto) {
      this.colorSegmentosSeleccionados = this.hexColorCapaCompletado;
    }
    this.avanceSeleccionado = null;
    this.infoWindowAbierto = false;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 10);
  }


  public onPropertyChange(valor: boolean, keyCatCapa: string): void {
    if (keyCatCapa === this.CAPA_COMPLETADO) {
      this.datosObra.avances.forEach((avance: AvanceDTO) => {
        avance.mostrarCapa = valor;
      });
    }
    this.datosObra.capasSegmentos.forEach((capaSegmentos: CapaSegmentosDTO) => {
      if (capaSegmentos.capa.keyCatCapa === keyCatCapa) {
        capaSegmentos.mostrarCapa = valor;
      }
    });

  }

  public async mapReady(event: any): Promise<void> {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.datosObra.capasSegmentos));
  }

  public crearArregloPolylines(capasSegmentos: CapaSegmentosDTO[]): any {
    let coordenadas: Array<Coordenada[]> = new Array<Coordenada[]>();
    capasSegmentos.forEach((capaSegmento) => {
      capaSegmento.segmentos.forEach((segmento: Segmento) => {
        coordenadas.push(segmento.coordenadas)
      });
    });
    return coordenadas.map((coordenadas: Coordenada[]) => this.crearPolyline(coordenadas))
  }

  public crearArregloPolylineProyecto(): Array<Coordenada[]> {
    let capaProyecto: CapaSegmentosDTO = this.datosObra.capasSegmentos.find((capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO || capa.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION)
    let segmentos: Array<Coordenada[]> = capaProyecto.segmentos.map((segmento: Segmento) => segmento.coordenadas);
    return segmentos;
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map(p => ({ lat: p.latitud, lng: p.longitud }))
    };
  }

  public async obtenerDatosLevantamiento(keyLevantamiento: string): Promise<void> {
    this.datosObra = await this.levantamientoObraService.findByKey(keyLevantamiento).pipe(
      take(1),
      concatMap((levObra: LevantamientoObra) => this.usuarioService.findByKey(levObra.keyUsuarioLevantamiento)
        .pipe(
          take(1),
          concatMap((usuarioLevantamiento: Usuario) => this.usuarioService.findByKey(levObra.keyUsuarioAprobacion)
            .pipe(
              take(1),
              map(
                (usuarioAprobo: Usuario) => {
                  let datosObra: LevantamientoSeleccionadoDTO = {};
                  datosObra.direccionAdjunta = this.catDireccionesAdjuntas.find((direccionAdjunta: ElementoCatalogo) => direccionAdjunta.key === levObra.keyCatDireccionAdjunta);
                  datosObra.tipoObra = this.catTipoObra.find((tipoObra: ElementoCatalogo) => tipoObra.key === levObra.keyCatTipoObra);
                  datosObra.estado = this.catEstados.find((estado: Estado) => estado.key === levObra.keyCatEstado);
                  datosObra.tipoLevantamiento = this.catTipoLevantamiento.find((tipoLevantamiento: ElementoCatalogo) => tipoLevantamiento.key === levObra.keyCatTipoLevantamiento);
                  datosObra.usuarioAprobo = usuarioAprobo;
                  datosObra.usuarioLevantamiento = usuarioLevantamiento;
                  datosObra.levObra = levObra;
                  return datosObra;
                }
              ),
              concatMap(
                (levSelDTO: LevantamientoSeleccionadoDTO) => this.capaService.findByKeyLevantamientoObra(levSelDTO.levObra.key)
                  .pipe(
                    take(1),
                    concatMap(
                      (capas: Capa[]) => from(capas)
                        .pipe(
                          concatMap(
                            (capa: Capa) => this.segmentoService.findByKeyCapa(capa.key)
                              .pipe(
                                take(1),
                                map(
                                  (segmentos: Segmento[]) => {
                                    let longitudSegmentos: number = 0;
                                    segmentos.forEach((segmento: Segmento) => {
                                      let path: Array<google.maps.LatLng> = Array.from(segmento.coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
                                      let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
                                      longitudSegmentos += parseFloat(longitudSegmento.toFixed(2));
                                    });
                                    let capaSegmentos: CapaSegmentosDTO = {
                                      capa,
                                      segmentos: segmentos.map(
                                        (segmento: Segmento) => (
                                          { ...segmento, nombreColor: this.catColores.find((e: ElementoCatalogo) => e.key === segmento.keyCatColor).nombre }
                                        )
                                      ),
                                      nombreCapa: this.catCapas.find((e: ElementoCatalogo) => e.key === capa.keyCatCapa).nombre,
                                      longitudSegmentos
                                    };
                                    return capaSegmentos;
                                  }
                                )
                              )
                          ),
                          toArray()
                        )
                    ),
                    map(
                      (capasSegmentos: CapaSegmentosDTO[]) => (
                        {
                          ...levSelDTO,
                          capasSegmentos
                        } as LevantamientoSeleccionadoDTO
                      )
                    )
                  )
              )
            )
          )
        )
      ),
      concatMap(
        (datosObraSeleccionada: LevantamientoSeleccionadoDTO) => this.archivoCoordenadaService.findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key).pipe(
          take(1),
          map(
            (archivos: ArchivoCoordenada[]) => {
              datosObraSeleccionada.capasSegmentos.forEach(
                (capaSegmentos: CapaSegmentosDTO) => {
                  capaSegmentos.segmentos.forEach(
                    (segmento: Segmento) => {
                      segmento.coordenadas.forEach(
                        (coordenada: Coordenada, indice: number) => {
                          let archivosEncontrados: ArchivoCoordenada[] = archivos.filter((a: ArchivoCoordenada) => a.keySegmento === segmento.key && a.keyCoordenada === indice.toString());
                          if (archivosEncontrados.length > 0) {
                            coordenada.archivos = archivosEncontrados;
                          } else {
                            coordenada.archivos = [];
                          }
                          coordenada.opacidad = 1;
                        }
                      );
                    }
                  );
                  capaSegmentos.mostrarCapa = true;
                  switch (capaSegmentos.capa.keyCatCapa) {
                    case this.CAPA_PROYECTO_PROCESO: capaSegmentos.zIndex = 10; break;
                    case this.CAPA_PROYECTO_PLANEACION: capaSegmentos.zIndex = 10; break;
                    case this.CAPA_META_ACTUAL: capaSegmentos.zIndex = 20; break;
                    case this.CAPA_COMPLETADO: capaSegmentos.zIndex = 30; break;
                    case this.CAPA_ESTRUCTURA: capaSegmentos.zIndex = 40; break;
                  }
                }
              );
              // Se crea el arreglo de avances. Cada avance tiene su propia fecha y un arreglo de segmentos. Se agrupan segmentos por fecha
              //  Ademas, ese arreglo de segmentos tiene un calculo con la suma de todas sus longitudes.
              let capaCompletado: CapaSegmentosDTO = datosObraSeleccionada.capasSegmentos.find((capaSegmentos: CapaSegmentosDTO) => capaSegmentos.capa.keyCatCapa === this.CAPA_COMPLETADO);
              let avances: AvanceDTO[] = [];
              if (capaCompletado) {
                let mapaFechas = new Map<number, Segmento[]>();
                capaCompletado.segmentos.forEach((segmento: Segmento) => {
                  let segmentos: Segmento[] = mapaFechas.get(segmento.fechaRegistro ? segmento.fechaRegistro : segmento.fechaCreacion);
                  if (!segmentos) {
                    segmentos = [];
                  }
                  segmentos.push(segmento);
                  mapaFechas.set(segmento.fechaRegistro ? segmento.fechaRegistro : segmento.fechaCreacion, segmentos);
                });

                mapaFechas.forEach((segmentos: Segmento[], fecha: number) => {
                  let longitudSegmentos: number = 0;
                  segmentos.forEach((segmento: Segmento) => {
                    let path: Array<google.maps.LatLng> = Array.from(segmento.coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
                    let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
                    longitudSegmentos += parseFloat(longitudSegmento.toFixed(2));
                  });

                  let avance: AvanceDTO = {
                    capa: capaCompletado.capa,
                    nombreCapa: capaCompletado.nombreCapa,
                    zIndex: capaCompletado.zIndex,
                    mostrarCapa: capaCompletado.mostrarCapa,
                    fecha,
                    segmentos,
                    longitudSegmentos
                  };

                  avances.push(avance);
                });
              }
              datosObraSeleccionada.avances = avances;

              return datosObraSeleccionada;
            }
          )
        )
      ),
      concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) => this.obraServuce.findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key).pipe(
        take(1),
        map((obra: Obra) => {
          let programadoExiste: boolean = false;
          obra.ejerciciosFiscales.forEach((ejercicioFiscal: EjercicioFiscal) => {
            if (ejercicioFiscal.esquemaFiscal < this.fechaActual.getFullYear()) {
              ejercicioFiscal.texto = "Avances hasta " + ejercicioFiscal.esquemaFiscal;
            } else if (ejercicioFiscal.esquemaFiscal === this.fechaActual.getFullYear() && !programadoExiste) {
              programadoExiste = true;
              ejercicioFiscal.texto = "Programado " + ejercicioFiscal.esquemaFiscal;
            } else if (ejercicioFiscal.esquemaFiscal === this.fechaActual.getFullYear() && programadoExiste) {
              ejercicioFiscal.texto = "Posterior a " + ejercicioFiscal.esquemaFiscal;
            } else if (ejercicioFiscal.texto > this.fechaActual.getFullYear()) {
              ejercicioFiscal.texto = "Posterior a " + ejercicioFiscal.esquemaFiscal;
            }
          });
          let lev: LevantamientoSeleccionadoDTO = {
            ...datosObraSeleccionada,
            obra
          };
          return lev;
        })
      )),
      take(1)
    ).toPromise();
    this.loaderService.desactivarLoaderScreen();
    if (this.datosObra.obra.ejerciciosFiscales.length > 0) {
      let contadorAnioActual: boolean = false;
      for (let index = 0; index < this.datosObra.obra.ejerciciosFiscales.length; index++) {
        if (this.datosObra.obra.ejerciciosFiscales[index].esquemaFiscal < this.fechaActual.getFullYear()) {
          this.avanceKmConcluido += this.datosObra.obra.ejerciciosFiscales[index].meta;
          this.avanceMdpConcluido += this.datosObra.obra.ejerciciosFiscales[index].asignacion;
          this.mostrarConcluido = true;
        }
        if (this.datosObra.obra.ejerciciosFiscales[index].esquemaFiscal === this.fechaActual.getFullYear() && !contadorAnioActual) {
          this.avanceKmActual += this.datosObra.obra.ejerciciosFiscales[index].meta;
          this.avanceMdpActual += this.datosObra.obra.ejerciciosFiscales[index].asignacion;
          contadorAnioActual = true;
          this.mostrarActual = true;
        }
        if (this.datosObra.obra.ejerciciosFiscales[index].esquemaFiscal === this.fechaActual.getFullYear() && contadorAnioActual) {
          this.avanceKmFaltante = 0;
          this.avanceMdpFaltante = 0;
          this.avanceKmFaltante += this.datosObra.obra.ejerciciosFiscales[index].meta;
          this.avanceMdpFaltante += this.datosObra.obra.ejerciciosFiscales[index].asignacion;
          this.mostrarFaltante = true;
        }
      }
    }
  }

  public cambiarCapaFederales(nombreCapa: string) {
    if (this.datosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === 'Completado') {
        return 'Terminado';
      } else if (nombreCapa === 'Meta actual') {
        // return `Programado ${this.anioActual}`;
        return 'Por modernizar';
      } else {
        return nombreCapa;
      }
    } else {
      return nombreCapa;
    }
  }

  public cambiarCapaColorFederales(nombreCapa: string, colorCapaOriginal: string) {
    if (this.datosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === 'Proyecto') {
        return this.catColores.find((e: ElementoCatalogo) => e.key === '3').nombre;
      } else {
        return colorCapaOriginal;
      }
    } else {
      return colorCapaOriginal;
    }
  }

  public descargarPDFCarta() {
    this.pdfUtils.descargarPDFLarguilloCarta();
  }
  public descargarPDFPlotter() {
    this.pdfUtils.descargarPDFLarguilloPlotter();
  }
}